// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
 
.solidLine::before,
.solidLine::after {
    display: inline-block;
    content: "";
    border-top: .2rem solid gold;
    width: 2rem;
    margin: 0 1rem;
    /* transform: translateY(-1rem); */
    transform: translateY(-150%);
}


.CMSCover{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  cursor: pointer;
  /* margin-left: 30px;
  padding-right: 30px; */
}

.CMSWording{
  width: 100%;
    text-align: center;
    display: flex;
    justify-content: space-around;

  }
  
.courseWholeCoverNew{
  display: flex;
  justify-content: space-around;
  width: 100%;
  /* background-color: aqua; */
  
  padding: 30px;
}

.wholeNewCard{
    display: flex;
    width: 80%;
    min-width: 80%;
    /* background-color: blueviolet; */
    height: 300px;
    border: 1px solid gray;
    border-radius: 5px;

}
.wholeNewCard:hover{
    transition: border all 1s;
    border: 2px solid gray;
   

}

.NewcourseImg{
 flex: 1 1;
 overflow: hidden;
}
.NewcourseImg img{
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.workingWholeCover{
  flex: 2 1;
  padding: 20px;
  overflow: hidden;
}

.courseMetrics {
  
    overflow: hidden;
}
.courseMetrics p{
  padding: 0;
  margin: 0;
  font-size :15px;
  /* background-color: red; */
}

@media screen and (max-width: 730px){    
  

     
.CMSCover .solidLine::before,
.CMSCover .solidLine::after {
    display: inline-block;
    content: "";
    border-top: .2rem solid gold;
    width: 0.7rem;
    margin: 0 10px;
    
    transform: translateY(-150%);
}



    .CMSWording{
         font-size: 10px;
    }

    .wholeNewCard{
      display: flex;
      flex-direction: column;
      display: flex;
      width: 95%;
      min-width: 80%;
      /* background-color: blueviolet; */
      height: auto;
      border: 1px solid gray;
      border-radius: 5px;
  
    }

    .NewcourseImg{
      flex: .5 1;
      overflow: hidden;
     }
    .NewcourseImg {

      width: 100%;
      height: 100%;
      overflow: hidden;

     }

}`, "",{"version":3,"sources":["webpack://./src/Components/CMSNews/CMSNews.css"],"names":[],"mappings":";;AAEA;;IAEI,qBAAqB;IACrB,WAAW;IACX,4BAA4B;IAC5B,WAAW;IACX,cAAc;IACd,kCAAkC;IAClC,4BAA4B;AAChC;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf;wBACsB;AACxB;;AAEA;EACE,WAAW;IACT,kBAAkB;IAClB,aAAa;IACb,6BAA6B;;EAE/B;;AAEF;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,4BAA4B;;EAE5B,aAAa;AACf;;AAEA;IACI,aAAa;IACb,UAAU;IACV,cAAc;IACd,kCAAkC;IAClC,aAAa;IACb,sBAAsB;IACtB,kBAAkB;;AAEtB;AACA;IACI,yBAAyB;IACzB,sBAAsB;;;AAG1B;;AAEA;CACC,SAAO;CACP,gBAAgB;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;;IAEI,gBAAgB;AACpB;AACA;EACE,UAAU;EACV,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;;;AAIA;;IAEI,qBAAqB;IACrB,WAAW;IACX,4BAA4B;IAC5B,aAAa;IACb,cAAc;;IAEd,4BAA4B;AAChC;;;;IAII;SACK,eAAe;IACpB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,aAAa;MACb,UAAU;MACV,cAAc;MACd,kCAAkC;MAClC,YAAY;MACZ,sBAAsB;MACtB,kBAAkB;;IAEpB;;IAEA;MACE,UAAQ;MACR,gBAAgB;KACjB;IACD;;MAEE,WAAW;MACX,YAAY;MACZ,gBAAgB;;KAEjB;;AAEL","sourcesContent":["\n \n.solidLine::before,\n.solidLine::after {\n    display: inline-block;\n    content: \"\";\n    border-top: .2rem solid gold;\n    width: 2rem;\n    margin: 0 1rem;\n    /* transform: translateY(-1rem); */\n    transform: translateY(-150%);\n}\n\n\n.CMSCover{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 20px;\n  cursor: pointer;\n  /* margin-left: 30px;\n  padding-right: 30px; */\n}\n\n.CMSWording{\n  width: 100%;\n    text-align: center;\n    display: flex;\n    justify-content: space-around;\n\n  }\n  \n.courseWholeCoverNew{\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n  /* background-color: aqua; */\n  \n  padding: 30px;\n}\n\n.wholeNewCard{\n    display: flex;\n    width: 80%;\n    min-width: 80%;\n    /* background-color: blueviolet; */\n    height: 300px;\n    border: 1px solid gray;\n    border-radius: 5px;\n\n}\n.wholeNewCard:hover{\n    transition: border all 1s;\n    border: 2px solid gray;\n   \n\n}\n\n.NewcourseImg{\n flex: 1;\n overflow: hidden;\n}\n.NewcourseImg img{\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.workingWholeCover{\n  flex: 2;\n  padding: 20px;\n  overflow: hidden;\n}\n\n.courseMetrics {\n  \n    overflow: hidden;\n}\n.courseMetrics p{\n  padding: 0;\n  margin: 0;\n  font-size :15px;\n  /* background-color: red; */\n}\n\n@media screen and (max-width: 730px){    \n  \n\n     \n.CMSCover .solidLine::before,\n.CMSCover .solidLine::after {\n    display: inline-block;\n    content: \"\";\n    border-top: .2rem solid gold;\n    width: 0.7rem;\n    margin: 0 10px;\n    \n    transform: translateY(-150%);\n}\n\n\n\n    .CMSWording{\n         font-size: 10px;\n    }\n\n    .wholeNewCard{\n      display: flex;\n      flex-direction: column;\n      display: flex;\n      width: 95%;\n      min-width: 80%;\n      /* background-color: blueviolet; */\n      height: auto;\n      border: 1px solid gray;\n      border-radius: 5px;\n  \n    }\n\n    .NewcourseImg{\n      flex: .5;\n      overflow: hidden;\n     }\n    .NewcourseImg {\n\n      width: 100%;\n      height: 100%;\n      overflow: hidden;\n\n     }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
